import React from "react"
import { Bar } from "react-chartjs-2"
import { Chart, registerables } from "chart.js"
import ChartDataLabels from "chartjs-plugin-datalabels"

Chart.register(...registerables, ChartDataLabels)

const BarChart = ({ data, options, width = 751, height = 500 }) => {
  return <Bar width={width} height={height} data={data} options={options} />
}

export default BarChart
